import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext.jsx";
import "../styles/auth.css";

/* Public self-registration (port of register.html). */
export default function Register() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [err, setErr] = useState("");
  const [ok, setOk] = useState(false);
  const [busy, setBusy] = useState(false);
  // null = still checking; false = an admin has closed self-registration.
  const [open, setOpen] = useState(null);

  useEffect(() => {
    fetch("/api/registration")
      .then((r) => r.json())
      .then((j) => setOpen(j.open !== false))
      .catch(() => setOpen(true));
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setOk(false);
    const f = e.target;
    const password = f.password.value;
    const confirm = f.confirm.value;
    if (password !== confirm) return setErr("Passwords do not match");
    if (password.length < 6)
      return setErr("Password must be at least 6 characters");
    setBusy(true);
    try {
      const r = await fetch("/api/register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username: f.username.value.trim(),
          first_name: f.firstName.value.trim(),
          password,
          confirm,
        }),
      });
      if (r.ok) {
        setOk(true);
        await refresh();
        navigate("/", { replace: true });
        return;
      }
      const j = await r.json().catch(() => ({}));
      setErr(j.error || "Registration failed");
    } catch {
      setErr("Network error — try again");
    }
    setBusy(false);
  };

  return (
    <div className="auth-body">
      <div className="auth-wrap">
        <aside className="auth-info">
          <div className="ibrand">
            <span className="logo">▦</span>
            <div>
              <div className="title">Liquidation Heatmap</div>
              <div className="subtitle">join in under a minute</div>
            </div>
          </div>
          <h2>Create your account</h2>
          <p className="lead">
            Sign up to explore the liquidation chart and the trading view. Access
            is permission-based — an admin can grant alerts, trading bots and more
            once you're in.
          </p>
          <ol className="steps">
            <li>
              <b>Create your account</b> — username, name and a password.
            </li>
            <li>
              <b>Start exploring</b> — you'll land with the Home page and the
              trading chart.
            </li>
            <li>
              <b>Request more access</b> — ask an admin to grant heatmap, alerts,
              trading bots, etc.
            </li>
          </ol>
        </aside>

        <form className="auth-card" onSubmit={submit} autoComplete="on">
          <div className="brand">
            <span className="logo">▦</span>
            <div>
              <div className="title">Create your account</div>
              <div className="subtitle">Liquidation Heatmap</div>
            </div>
          </div>
          {open === false ? (
            <div className="blurb">
              Registration is currently closed. Ask an admin to create an
              account for you.
            </div>
          ) : (
            <>
            <div className="blurb">
              New accounts start with access to the Home page and the trading chart.
              An admin can grant more later.
            </div>
  
            <label htmlFor="firstName">First name</label>
            <input id="firstName" name="firstName" autoComplete="given-name" autoFocus />
  
            <label htmlFor="username">Username</label>
            <input id="username" name="username" autoComplete="username" required />
            <div className="hint">At least 3 characters — letters, digits, . _ -</div>
  
            <label htmlFor="password">Password</label>
            <input id="password" name="password" type="password" autoComplete="new-password" required />
            <div className="hint">At least 6 characters.</div>
  
            <label htmlFor="confirm">Confirm password</label>
            <input id="confirm" name="confirm" type="password" autoComplete="new-password" required />
  
            <button type="submit" disabled={busy || open === null}>
              Create account
            </button>
            <div className={"err" + (ok ? " ok" : "")}>
              {ok ? "Account created — taking you in…" : err}
            </div>
            </>
          )}
          <div className="alt">
            Already have an account? <Link to="/login">Sign in</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
